import UpdateDeliveryModal from './UpdateDeliveryModal'

export default UpdateDeliveryModal;
